// @flow
/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    nameChangeError: {
        id: 'device.name-change-error',
        defaultMessage: 'Home name could not be changed'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/homes/intl.js